import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import language from 'element-ui/lib/locale/lang/ru-RU';
import { Carousel, CarouselItem, Dialog, Image } from 'element-ui';

locale.use(language);

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dialog);
Vue.use(Image);



// WEBPACK FOOTER //
// ./src/plugins/element-ui/index.js